module.exports = __webpack_public_path__ + "static/media/vae.dd94a6e0.webp";